import { Box } from "@mui/material"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/system"
import { AdminUserCard } from "components/AdminUserCard"
import ConventionAvailableMeetingTime from "models/convention-api/v1/ConventionAvailableMeetingTime"
import ConventionMeetingType from "models/convention-api/v1/ConventionMeetingType"
import pluralize from "pluralize"
import React from "react"

interface MeetingReviewCardProps {
  meetingTime: ConventionAvailableMeetingTime
  meetingType: ConventionMeetingType
}

const MeetingReviewCard = (props: MeetingReviewCardProps) => {
  const { meetingTime, meetingType } = props

  const { meetingAvailability } = meetingTime
  const { adminUser } = meetingAvailability!

  const meetingDateText = meetingTime.start_at.format("MMM, DD YYYY hh:mmA")
  const durationText = `${meetingType.duration_minutes} ${pluralize(
    "minute",
    meetingType.duration_minutes,
  )}`

  return (
    <_Container>
      <_MeetingTypeName component="h5">{meetingType.name}</_MeetingTypeName>
      <_MeetingDetails component="p">
        <span>{meetingDateText}</span>
        <span>·</span>
        <span>{durationText}</span>
        <span>·</span>
        <span>Video Call</span>
      </_MeetingDetails>
      <AdminUserCard adminUser={adminUser!} />
    </_Container>
  )
}

export default MeetingReviewCard

const _Container = Box

const _MeetingTypeName = styled(Typography)(({ theme }) => ({
  ...theme.fonts.raleway700,
  fontSize: 16,
  margin: 0,
})) as typeof Typography

const _MeetingDetails = styled(Typography)(({ theme }) => ({
  ...theme.fonts.lato400,
  fontSize: 16,
  marginTop: 0,
  marginBottom: 4,

  "& > * + *": {
    marginLeft: "5px",
  },
})) as typeof Typography
